var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('s-toolbar',{staticClass:"tran",attrs:{"color":'#244093',"dark":"","label":"Reporte de Usos"}}),_c('clc-report-use-dinamic')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }